import React, { useEffect, useMemo, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel
} from '@mui/material';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer, DatePicker } from 'components';

import L from 'leaflet';
import _ from 'underscore';

import { enqueueSnackbar } from 'actions';
import {
	SetFormState,
	ResetFields,
	GetUtilizationDates,
	GetTrafficPctAddOptions,
	SetSelectedUtilizationDateCompare,
	SetSelectedTrafficPctAdd
} from '../../actions/DualMapActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const UtilizationDatesCompare = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.dualMapReducer.formState);
	const utilizationDates = useSelector((state) => state.dualMapReducer.utilizationDates);
	const trafficPctAddOptions = useSelector((state) => state.dualMapReducer.trafficPctAddOptions);
	const selectedUtilizationDateCompare = useSelector((state) => state.dualMapReducer.selectedUtilizationDateCompare);

	const userId = useSelector(state => state.session.user.id);
	// const userOperator = useSelector(state => state.session.user.operator);

	const _handleChangeDate = (event) => {
		dispatch(SetSelectedUtilizationDateCompare(event.target.value));
	};

	const _handleChangeTrafficPctAdd = (event) => {
		dispatch(SetSelectedTrafficPctAdd(event.target.value));
	};

	const _getData = () => {
		dispatch(ResetFields());
	};

	useEffect(() => {
		_getData();
	}, []);

	useEffect(() => {
		dispatch(SetSelectedUtilizationDateCompare(utilizationDates[0] && utilizationDates[0].text));
		dispatch(GetTrafficPctAddOptions());
		dispatch(SetSelectedTrafficPctAdd('0'));
	}, [utilizationDates]);

	return (

		<div className={clsx(classes.container)}>
			<Card className={classes.container}>
				<CardContent>
					<Grid container spacing={2} justifyContent="center">
						<Grid item lg={4} md={4} sm={12} className={classes.item}>
							<SelectField
								id="selectedUtilizationDateCompare"
								name="selectedUtilizationDateCompare"
								hintText="Choose Week"
								defaultValue={selectedUtilizationDateCompare}
								value={selectedUtilizationDateCompare}
								menuItems={utilizationDates || []}
								onChange={_handleChangeDate}
							/>
						</Grid>
						<Grid item lg={4} md={4} sm={12} className={classes.item}>
							<SelectField
								id="utlizationPctAdd"
								name="utlizationPctAdd"
								hintText="Add Traffic Percentage"
								menuItems={trafficPctAddOptions || []}
								onChange={_handleChangeTrafficPctAdd}
							/>
						</Grid>
						<Grid item lg={4} md={4} sm={12} className={classes.item} />
					</Grid>
				</CardContent>
			</Card>
		</div>

	);
};

export default UtilizationDatesCompare;
